import { render, staticRenderFns } from "./BookingRequests.vue?vue&type=template&id=0d9a9c9c&scoped=true"
import script from "./BookingRequests.vue?vue&type=script&lang=js"
export * from "./BookingRequests.vue?vue&type=script&lang=js"
import style0 from "./BookingRequests.vue?vue&type=style&index=0&id=0d9a9c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9a9c9c",
  null
  
)

export default component.exports